import React from "react";
import { CalendarCheck, Search, FileEdit, HandshakeIcon } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: CalendarCheck,
    title: "Agenda tu consulta",
    desc: "Contáctanos por WhatsApp, teléfono o formulario. Coordinamos una reunión presencial o virtual.",
  },
  {
    n: "02",
    icon: Search,
    title: "Analizamos tu caso",
    desc: "Revisamos tu situación en detalle, resolvemos tus dudas y te explicamos las opciones con transparencia.",
  },
  {
    n: "03",
    icon: FileEdit,
    title: "Preparamos la documentación",
    desc: "Nos encargamos de todos los formularios, cálculos y trámites necesarios de principio a fin.",
  },
  {
    n: "04",
    icon: HandshakeIcon,
    title: "Te acompañamos hasta el final",
    desc: "Damos seguimiento a tu caso hasta que se resuelva satisfactoriamente. Estamos contigo en cada paso.",
  },
];

export default function HowWeWork() {
  return (
    <section id="proceso" className="py-24 lg:py-32 bg-white relative" data-testid="how-we-work-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl reveal">
          <div className="text-xs font-semibold text-[#0B2D5C] tracking-[0.2em] uppercase mb-4">
            Nuestro proceso
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0f172a] leading-[1.1]">
            Cómo{" "}
            <span className="text-[#0B2D5C]">trabajamos</span> contigo
          </h2>
          <p className="mt-5 text-lg text-[#475569] leading-relaxed">
            Un proceso simple, claro y humano. Desde el primer contacto hasta la resolución de tu trámite.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-14 left-[12.5%] right-[12.5%] h-px border-t-2 border-dashed border-[#e2e8f0] -z-10"></div>

          {STEPS.map((step, i) => (
            <div
              key={step.n}
              className="reveal relative"
              style={{ transitionDelay: `${i * 80}ms` }}
              data-testid={`step-${i}`}
            >
              <div className="flex flex-col items-start">
                <div className="relative">
                  <div className="w-16 h-16 rounded-sm bg-[#0B2D5C] flex items-center justify-center shadow-lg z-10 relative">
                    <step.icon className="text-white" size={26} strokeWidth={1.75} />
                  </div>
                  <div className="absolute -top-3 -right-3 bg-[#C89B2C] text-[#0f172a] text-xs font-bold px-2 py-1 rounded-sm">
                    {step.n}
                  </div>
                </div>
                <h3 className="font-display font-semibold text-lg text-[#0f172a] mt-6 mb-2">{step.title}</h3>
                <p className="text-[15px] text-[#475569] leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
